import { create } from 'zustand'

export const useRatesStore = create((set) => ({
    nanyRate: {
      min: 0,
      max: 60,
    },
    generalRate: {
      min: 0,
      max: 60,
    },
    secondaryRate: {
      min: 0,
      max: 60,
    },
    tutorRate: {
      min: 0,
      max: 60,
    },

    setNanyRate: (newRate) => set({ nanyRate: newRate }),
    setGeneralRate: (newRate) => set({ generalRate: newRate }),
    setSecondaryRate: (newRate) => set({ secondaryRate: newRate }),
    setTutorRate: (newRate) => set({ tutorRate: newRate }),
  }));